import {
    SET_SELECT_CATEGORY,
    SET_ESTIMATE_ITEMS,
    SET_COMPARE_ITEMS,
    SET_CHANGE_ITEM,
    SET_ESTIMATE_ITEM_CHECKED,
    SET_MINISHOP,
    SET_ESTIMATE_MODE,
    SET_CATEGORY_DATA,
    SET_PRICE_TYPE,
    UPDATE_LIKE_COMPARE_ITEM,
    SET_COMPARE_VIEW, SET_COMPARE_VIEW_MODAL,
    SET_SELECT_ONLY_ONE_SERVICE_ASSEMBLE_MODAL, SET_STOCK_LABEL_LAYER, SET_YOUTUBE_LAYER
} from '../libs/action'

const initialState = {
    categoryData: {},
    estimateItems: '',
    estimateCategoryItems: '',
    compareItems: [],
    displayPanel: 'estimate',
    estimateChangeItem: '',
    estimateChecked: {},
    miniShopInfo: { shopID: '', shopNO: 1 },
    estimateMode: null,
    priceType: 'cash',
    compareView: {}, // 상품사양 비교 새창
    isOpenCompareViewModal: false, // 상품 비교 10개 이상 선택 시 modal
    displayOnlyOneServiceAssembleModal: { // 서비스 조립 상품 중 하나만 선택 가능한 경우 modal
        isOpen: false,
        text : ''
    },
    showStockLabelLayer: false,
    showYoutubeLayer: false,

}

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_SELECT_CATEGORY:
            return Object.assign({}, state, { selectCategory: action.selectCategory })
        case SET_CATEGORY_DATA:
            return Object.assign({}, state, { categoryData: action.categoryData })
        case SET_ESTIMATE_ITEMS:
            return Object.assign({}, state, { estimateItems: action.estimateItems })
        case SET_ESTIMATE_ITEM_CHECKED:
            return Object.assign({}, state, { estimateChecked: action.estimateChecked })
        case SET_COMPARE_ITEMS:
            return Object.assign({}, state, { compareItems: action.compareItems })
        case UPDATE_LIKE_COMPARE_ITEM: // 상품 찜하기
            const copiedArray = Object.assign([], state.compareItems);
            let newCompareItems = copiedArray[action.itemIndex]
            if (action.zzimSelected === 1){
                newCompareItems[5] = '1'
            }
            if (action.zzimSelected === 0){
                newCompareItems[5] = '0'
            }
            return Object.assign({}, state, { compareItems: copiedArray })
        case SET_CHANGE_ITEM:
            return Object.assign({}, state, { estimateChangeItem: action.estimateChangeItem })
        case SET_MINISHOP:
            return Object.assign({}, state, { miniShopInfo: action.miniShopInfo })
        case SET_ESTIMATE_MODE:
            return Object.assign({}, state, { estimateMode: action.estimateMode })
        case SET_PRICE_TYPE:
            return Object.assign({}, state, { priceType: action.priceType })
        case SET_COMPARE_VIEW:
            return Object.assign({}, state, { compareView: action.compareView })
        case SET_COMPARE_VIEW_MODAL:
            return Object.assign({}, state, { isOpenCompareViewModal: action.isOpenModal })
        case SET_SELECT_ONLY_ONE_SERVICE_ASSEMBLE_MODAL :
            return Object.assign({}, state, { displayOnlyOneServiceAssembleModal: action.isOpenModal })
        case SET_STOCK_LABEL_LAYER :
            return Object.assign({}, state, { showStockLabelLayer: action.isOpenModal })
        case SET_YOUTUBE_LAYER :
            return Object.assign({}, state, { showYoutubeLayer: action.isOpenModal })

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/estimate_list/reducers/estimateAdd.js